export default __webpack_public_path__ + "static/media/padvamathi-thakur.d7ccce19.png";